export function getMovieTime(url) {
  const video = document.createElement('video')
  video.src = url
  return new Promise((resolve) => {
    video.oncanplay = () => { resolve(video.duration) }
  })
}


export const getMovieSize = (url) => {
  const video = document.createElement('video')
  video.src = url
  return new Promise((resolve) => {
    video.oncanplay = () => { resolve({ width: video.videoWidth, height: video.videoHeight }) }
  })
}
